import React, { useState } from "react";
import "./VirasatDefaultPageWrapper.scss"
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import VirasatLeftDrawer from "./components/VirasatLeftDrawer/VirasatLeftDrawer";
import ComingSoonModal from "./components/ComingSoonModal/ComingSoonModal";
import { useSelector } from "react-redux";

const VirasatDefaultPageWrapper = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const iscoming = useSelector((state) => state.companyData.isComing)

    return (
        <div className="VirasatDefaultPageWrapper">
            <VirasatLeftDrawer
                isOpen={isMenuOpen}
                setIsOpen={setIsMenuOpen} />
            <Navbar
                setIsMenuOpen={setIsMenuOpen} />
            {children}
            {iscoming && <ComingSoonModal />}

            <Footer />
        </div>
    )
}
export default VirasatDefaultPageWrapper